import script from "./StreamsManage.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManage.vue?vue&type=script&setup=true&lang=js"

import "./StreamsManage.vue?vue&type=style&index=0&id=890ee2f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-890ee2f4"]])

export default __exports__